//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const RbLoading = () =>
  import(/* webpackChunkName: "loader-chunk" */ '@/elements/loading/rb-loading.vue')

import { mapGetters } from 'vuex'

import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import RbDynamicSwiperSlide from './dynamic-swiper-slide'
import rbDynamicGridColumn from './dynamic-grid-column'

export default {
  name: 'rb-smart-container',
  components: {
    RbDynamicSwiperSlide,
    rbDynamicGridColumn,
    RbLoading,
  },
  props: {
    centeredSlides: {
      type: Boolean,
      default: false,
    },
    fullScreenMobile: {
      type: Boolean,
      default: false,
    },
    slidesPerViewDesktop: {
      type: Number,
      default: 4,
    },
    slidesPerViewTablet: {
      type: Number,
      default: 3,
    },
    slidesPerViewMobile: {
      type: Number,
      default: 1,
    },
    columnsOfNextSlide: {
      type: Number,
      default: 1,
    },
    swiperTheme: {
      type: String,
      default: 'dark',
    },
    navigation: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Boolean,
      default: true,
    },
    stackedOnMobile: {
      type: Boolean,
      default: false,
    },
    stackedOnTablet: {
      type: Boolean,
      default: false,
    },
    stackedOnDesktop: {
      type: Boolean,
      default: false,
    },
    spaceBetweenSlides: {
      type: Number,
      default: 8,
    },
    slidesPerGroup: {
      type: Number,
      default: 1,
    },
    nextNavigation: {
      type: Object,
      default: () => undefined,
    },
    prevNavigation: {
      type: Object,
      default: () => undefined,
    },
    withNavigationArrows: {
      type: Boolean,
      default: true,
    },
    columnGap: {
      type: Number,
      default: 1,
    },
    alwaysShowSwiper: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      snapIndex: 0,
    }
  },
  computed: {
    ...mapGetters(['translation']),
    defaultConfig() {
      return {
        spaceBetween: this.spaceBetweenSlides,
        grabCursor: false,
        slidesPerGroup: this.slidesPerGroup,
        centeredSlides: this.centeredSlides,
        breakpoints: {
          1024: {
            slidesPerView: `${this.$props.slidesPerViewDesktop}.${this.columnsOfNextSlide}`,
          },
          600: {
            slidesPerView: `${this.$props.slidesPerViewTablet}.${this.columnsOfNextSlide}`,
          },
          320: {
            slidesPerView: this.isFullScreenMobile(),
          },
        },
        touchStartPreventDefault: false,
      }
    },
    showSwiper() {
      if (this.alwaysShowSwiper) {
        return true
      }
      if (this.isStackedOnTablet) {
        return false
      }
      if (this.isStackedOnMobile) {
        return false
      }
      if (this.$mq === MOBILE) {
        return this.$props.slidesPerViewMobile < this.swiperSlides?.length
      } else if (this.$mq === TABLET) {
        return this.$props.slidesPerViewTablet < this.swiperSlides?.length
      } else {
        return this.$props.slidesPerViewDesktop < this.swiperSlides?.length
      }
    },
    isStackedOnMobile() {
      return this.$mq === MOBILE && this.stackedOnMobile
    },
    isStackedOnTablet() {
      return this.$mq === TABLET && this.stackedOnTablet
    },
    swiperSlides() {
      return this.$slots.default?.filter((slot) => !!slot.tag)
    },
    isSwiperThemeLight() {
      return this.$props.swiperTheme == 'light'
    },
    arrowColor() {
      if (this.$props.swiperTheme == 'light') {
        return ''
      } else {
        return 'light-'
      }
    },
  },
  methods: {
    isFullScreenMobile() {
      return this.fullScreenMobile
        ? `${this.$props.slidesPerViewMobile}.0`
        : `${this.$props.slidesPerViewMobile}.${this.columnsOfNextSlide}`
    },
    emitSwiperNext(currentSlide) {
      this.$emit('swiperNext', currentSlide)
    },
    emitSwiperPrev(currentSlide) {
      this.$emit('swiperPrev', currentSlide)
    },
    emitSnapIndexChange(snapIndex) {
      this.snapIndex = snapIndex
      this.$emit('snapIndexChange', snapIndex)
    },
    goToSlide(index) {
      this.$refs.swiperRef.swiper?.slideTo(index)
    },
  },
}
